import type { HyperEntityConfig } from "@shared/backend/hyper-entity.decorator";
import { Roles } from "@shared/Roles";
import { Allow } from "remult";
import { type Vehicle } from "./entity";

export const VehicleEntityConfig: HyperEntityConfig<Vehicle> = {
  allowApiCrud: Allow.authenticated,
  apiPrefilterPerRole(filter) {
    filter(Roles.All, true);
  },

  allowInsertPerRole(allow) {
    allow(Roles.SuperDuperAdmin, true);
  },

  allowDeleteAndUpdatePerRole(allow) {
    allow(Roles.SuperDuperAdmin, true);
  },
};
